import React, { useEffect } from 'react';
import './App.css';
import './design/sass/main.scss';
import './components/togglelightmode/toggle-mode.css';
import { useRoutes, useLocation } from 'react-router-dom';
import ScrollToTop from '~/components/common/ScrollToTop';
import Router from '~/routes/Router';
import { useThemeMode } from './components/common/AppStoreStyle';
import GoogleAnalytics from 'react-ga4';
import { getSession } from '~/services/auth/authService';
import { AbcLoginResult, tokenLogin } from '~/services/abcWaas/login';
import {
  createSecureChannel,
  securechannel,
} from '~/services/abcWaas/securechannel';
import { recoveryWallet } from '~/services/abcWaas/mpc';
import {
  Eip1559Result,
  encrypt,
  estimate,
  getEncryptPlain,
  getGasData,
  LegacyResult,
  receipt,
  sendTx,
  sign,
} from '~/services/abcWaas/transaction';
import env from '~/env';
import { ethers } from 'ethers';
import { RPC_URLS } from '~/config';
import Caver from 'caver-js';

let abcFlag = false;

export interface AbcWalletResult {
  encryptDevicePassword: string;
  ourpubkey: string;
  pvencstr: string;
  sid: string;
  ucpubkey: string;
  uid: string;
  wid: number;
}

function App() {
  const routing = useRoutes(Router());
  const { pathname } = useLocation();

  window.onerror = function (message, source, lineno, colno, error) {
    console.error('!!!!! Global error handler:', message, error);
  };

  window.addEventListener('unhandledrejection', (event) => {
    console.error(`UNHANDLED PROMISE REJECTION #1: ${event?.reason?.message}`);
    if (
      event &&
      event.reason &&
      event.reason.message &&
      event?.reason?.message.includes(
        'session topic does not exist in keychain:'
      )
    ) {
      const req = indexedDB.deleteDatabase('WALLET_CONNECT_V2_INDEXED_DB');
      req.onsuccess = function () {
        console.log('Deleted database successfully');
        window.location.reload();
      };
      req.onerror = function () {
        console.log("Couldn't delete database");
      };
      req.onblocked = function () {
        console.log(
          "Couldn't delete database due to the operation being blocked"
        );
      };
    }
  });
  window.onunhandledrejection = (event) => {
    console.error(`UNHANDLED PROMISE REJECTION #2: ${event.reason}`);
  };

  //set dark light mode
  const { lightMode, darkMode } = useThemeMode();
  const setDark = () => {
    localStorage.setItem('theme', 'dark');
    document.documentElement.setAttribute('data-theme', 'dark');
    darkMode();
  };

  const setLight = () => {
    localStorage.setItem('theme', 'light');
    document.documentElement.setAttribute('data-theme', 'light');
    lightMode();
  };
  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    const defaultDark = storedTheme === 'dark' || storedTheme === null;

    if (defaultDark) {
      setDark();
    } else {
      setLight();
    }
  }, []);

  // let isLoad = false;
  // useEffect(() => {
  //   // if (isLoad) return;
  //   const abcLogin = async () => {
  //     if (abcFlag) return;
  //     abcFlag = true;
  //
  //     const rlt = await getSession();
  //     const login = window.localStorage.getItem('login');
  //     if (rlt.data?.providerAuthInfo && login === 'sns') {
  //       // await HelperUtil.abcRecoverNew();
  //       console.log('########## Do ABC RECOVER from here ##########');
  //       const authInfo = rlt.data?.providerAuthInfo;
  //       console.log('### session info : ', authInfo);
  //       // await tokenLogin(rlt.data?.providerAuthInfo.provider_token, rlt.data?.providerAuthInfo.provider);
  //
  //       const secureChannelRes: securechannel = await createSecureChannel();
  //       console.log('### Secure Channel created : ', secureChannelRes);
  //
  //       await recoveryWallet(authInfo.provider_token, authInfo.provider)
  //
  //       /*
  //       const wallet: AbcWalletResult = JSON.parse(window.sessionStorage.getItem('abcWallet') || '{}');
  //       const secureChannel = JSON.parse(window.sessionStorage.getItem('secureChannel') || '{}');
  //
  //       // const result = await sendTx({
  //       //   network: env.REACT_APP_TARGET_NETWORK_KLAY === 8217 ? "kaia" : "kaia_kairos",
  //       //   from: wallet.sid,
  //       //   to: '0x1716C4d49E9D81c17608CD9a45b1023ac9DF6c73',
  //       //   gasLimit: '1000000',
  //       //   value: '100000000000000',
  //       //   data: '0x',
  //       // }, 'EIP1559')
  //       // console.log('### sendTx result : ', result);
  //
  //       const encryptDevicePassword = await getEncryptPlain(wallet.encryptDevicePassword);
  //       const pvencstr = await getEncryptPlain(wallet.pvencstr);
  //       const wid = await getEncryptPlain(wallet.wid.toString());
  //
  //
  //       const gasData: Eip1559Result = await getGasData(
  //         env.REACT_APP_TARGET_NETWORK_KLAY === 8217 ? "kaia" : "kaia_kairos",
  //         'EIP1559'
  //       );
  //       console.log('### gasData : ', gasData);
  //
  //       const gasLimit = await estimate({
  //         network: env.REACT_APP_TARGET_NETWORK_KLAY === 8217 ? "kaia" : "kaia_kairos",
  //         from: wallet.sid,
  //         to: '0x1716C4d49E9D81c17608CD9a45b1023ac9DF6c73',
  //         gasLimit: '1000000',
  //         value: '100000000000000',
  //         data: '0x',
  //       }, 'EIP1559')
  //       console.log('### gasLimit result : ', gasLimit);
  //
  //       const serializedTx: string = await sign({
  //         network: env.REACT_APP_TARGET_NETWORK_KLAY === 8217 ? "kaia" : "kaia_kairos",
  //         // from: wallet.sid,
  //         to: '0x1716C4d49E9D81c17608CD9a45b1023ac9DF6c73',
  //         gasLimit,
  //         value: '100000000000000',
  //         // data: '0x',
  //         maxPriorityFeePerGas: ethers.utils.parseUnits(gasData.high.suggestedMaxPriorityFeePerGas, 'gwei').toHexString(),
  //         maxFeePerGas: ethers.utils.parseUnits(gasData.high.suggestedMaxFeePerGas, 'gwei').toHexString(),
  //         type: 'EIP1559',
  //         // type: 'LEGACY',
  //         encryptDevicePassword,
  //         pvencstr,
  //         uid: wallet.uid,
  //         wid,
  //         sid: wallet.sid,
  //       }, secureChannel.ChannelID);
  //       console.log('### sign result : ', serializedTx);
  //
  //       const hash = await receipt(env.REACT_APP_TARGET_NETWORK_KLAY === 8217 ? "kaia" : "kaia_kairos", '0x760f0d012a233e17d6c2010f8e974bb3867557fae3edb0f6f02154931cacba68');
  //       console.log('### receipt result : ', hash); // or undefined
  //
  //       const targetChainId = parseInt(window.localStorage.getItem('target') ?? '8217');
  //       if (targetChainId !== 8217 && targetChainId !== 1001) {
  //         const provider = new ethers.providers.JsonRpcProvider(RPC_URLS[targetChainId]);
  //         if (!provider) {
  //           console.error('Provider not found');
  //         }
  //         const txResponse = await provider.sendTransaction(serializedTx);
  //         const receipt = await txResponse.wait();
  //         if (receipt.status === 1) {
  //           console.error('Transaction success:', receipt);
  //         } else {
  //           console.error('Transaction failure:', receipt);
  //         }
  //       } else {
  //         // TODO: Klaytn 의 경우 caver 를 사용하여 tx 를 broadcast 하여야 함.
  //         const caver = new Caver(RPC_URLS[targetChainId]);
  //         const txResponse = await caver.rpc.klay.sendRawTransaction(serializedTx);
  //         const receipt = await caver.rpc.klay.getTransactionReceipt(txResponse.transactionHash);
  //         console.log('$$$$$$$$$$$$$$$$', receipt?.status)
  //         if (receipt?.status === '0x1') {
  //           console.error('Transaction success:', receipt);
  //         } else {
  //           console.error('Transaction failure:', receipt);
  //         }
  //       }
  //       */
  //
  //       window.localStorage.setItem('wallet', 'abc');
  //       window.localStorage.setItem('walletStatus', 'connected');
  //     }
  //   };
  //
  //   abcLogin();
  //   isLoad = true;
  // }, []);

  GoogleAnalytics.set({
    pathname,
    title: 'studio.talken.io' + pathname,
  });
  GoogleAnalytics.send({ hitType: 'pageview', page: pathname });
  return (
    <>
      <ScrollToTop />
      {routing}
    </>
  );

  // return (
  //   <ThemeProvider theme={theme}>
  //     <Box className="App">{routing}</Box>
  //   </ThemeProvider>
  // );
}

export default App;
